/**
 * forms.js — Form interactions for OnFire Hockey theme
 * Handles: payment method toggle, event param reading, dynamic title injection
 */

(function () {
  'use strict';

  /**
   * Initialize payment method toggle buttons
   * Supports both USA Camp (Card/iDEAL) and Inschrijven (iDEAL/Creditcard) forms
   */
  function initPaymentToggles() {
    var toggleContainers = document.querySelectorAll('[data-payment-toggle]');

    toggleContainers.forEach(function (container) {
      var buttons = container.querySelectorAll('.payment-method');
      var cardFields = container
        .closest('form')
        ?.querySelector('[data-card-fields]');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          // Update active state on all buttons in this container
          buttons.forEach(function (b) {
            b.classList.remove('active');
            b.style.borderColor =
              'rgba(var(--color-outline-variant-rgb, 128,128,128), 0.2)';
            b.style.background = 'var(--color-surface-container)';
            b.style.opacity = '0.5';
          });

          // Activate clicked button
          btn.classList.add('active');
          btn.style.borderColor = 'var(--color-primary)';
          btn.style.background = 'var(--color-surface-container-highest)';
          btn.style.opacity = '1';

          // Toggle card fields visibility (USA Camp form)
          if (cardFields) {
            var method = btn.getAttribute('data-method');
            cardFields.style.display = method === 'card' ? 'block' : 'none';
          }
        });
      });

      // Set initial state for active button
      var activeBtn = container.querySelector('.payment-method.active');
      if (activeBtn) {
        activeBtn.style.borderColor = 'var(--color-primary)';
        activeBtn.style.background = 'var(--color-surface-container-highest)';
        activeBtn.style.opacity = '1';
      }
    });
  }

  /**
   * Initialize on DOM ready
   */
  function init() {
    initPaymentToggles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
